var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.542 59.7513V84.6471C109.542 99.5846 99.5835 109.543 84.646 109.543H37.9912C39.5348 108.248 40.879 106.655 41.9247 104.863C43.767 101.875 44.8127 98.3398 44.8127 94.6055C44.8127 83.6015 35.9 74.6888 24.896 74.6888C18.921 74.6888 13.5933 77.3277 9.9585 81.4604V59.7513C9.9585 46.208 18.1243 36.7475 30.8212 35.1542C32.1158 34.955 33.4602 34.8555 34.8543 34.8555H84.646C85.9406 34.8555 87.1854 34.9052 88.3804 35.1044C101.227 36.5981 109.542 46.1084 109.542 59.7513Z",
    stroke: "#A461D8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3873 35.1017C87.1923 34.9025 85.9475 34.8528 84.6529 34.8528H34.8612C33.4671 34.8528 32.1227 34.9523 30.8281 35.1515C31.5252 33.7573 32.5211 32.4629 33.7161 31.2679L49.8984 15.0358C56.7199 8.26411 67.7734 8.26411 74.5949 15.0358L83.3084 23.8487C86.4951 26.9856 88.1881 30.969 88.3873 35.1017Z",
    stroke: "#A461D8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.542 62.2383H94.6043C89.1272 62.2383 84.646 66.7195 84.646 72.1966C84.646 77.6737 89.1272 82.1549 94.6043 82.1549H109.542",
    fill: "#A461D8",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.542 62.2383H94.6043C89.1272 62.2383 84.646 66.7195 84.646 72.1966C84.646 77.6737 89.1272 82.1549 94.6043 82.1549H109.542",
    stroke: "#A461D8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8123 94.6042C44.8123 98.3385 43.7666 101.874 41.9243 104.861C40.8787 106.654 39.5344 108.247 37.9909 109.542C34.5055 112.679 29.9246 114.521 24.8957 114.521C17.6261 114.521 11.3026 110.637 7.86701 104.861C6.02471 101.874 4.979 98.3385 4.979 94.6042C4.979 89.5752 6.87109 84.9943 9.95817 81.4591C13.593 77.3264 18.9207 74.6875 24.8957 74.6875C35.8996 74.6875 44.8123 83.6002 44.8123 94.6042Z",
    stroke: "#A461D8",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2311 99.7833L19.7251 89.2773",
    stroke: "#A461D8",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0753 89.4336L19.5693 99.9396",
    stroke: "#A461D8",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletRemove);
export default __webpack_public_path__ + "static/media/wallet-remove.c3169de75ff28bb746146f25d92fd1df.svg";
export { ForwardRef as ReactComponent };